import { Button } from "../ui/button";
import { ArrowRight, Check } from "lucide-react";

const Assessment = () => {
  return (
    <section id="assessment" className="py-12 lg:py-14">
      <div className="container-tight">
        <div className="overflow-hidden rounded-3xl border border-border bg-card shadow-elevated">
          <div className="grid lg:grid-cols-12">
            <div className="border-b border-border p-10 lg:col-span-7 lg:border-b-0 lg:border-r lg:p-14">
              <div className="signal-chip">
                <span className="h-1.5 w-1.5 rounded-full bg-signal" /> Assessment
              </div>
              <h2 className="mt-5 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
                Start your Signal AI assessment.
              </h2>

              <div className="mt-6 inline-flex items-center gap-3 rounded-full border border-signal/30 bg-signal-soft px-4 py-2">
                <span className="text-xl font-semibold text-signal">$0</span>
                <span className="text-sm text-foreground">Get started no upfront commitment</span>
              </div>

              <p className="mt-6 text-base leading-relaxed text-muted-foreground">
                Answer a few practical questions about your workflows, data, and priorities. This helps identify:
              </p>
              <ul className="mt-5 space-y-3">
                {["Your AI readiness", "Where ROI exists", "What should be executed first"].map((i) => (
                  <li key={i} className="flex items-center gap-3 text-base text-foreground">
                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-signal/10">
                      <Check className="h-3 w-3 text-signal" strokeWidth={3} />
                    </span>
                    {i}
                  </li>
                ))}
              </ul>

              <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
                <Button asChild size="lg" className="group h-12 rounded-full bg-foreground px-7 text-base text-background shadow-elevated hover:bg-slate-mid">
                  <a href="/assessment">
                    Get My AI ROI View
                    <ArrowRight className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                  </a>
                </Button>
                <span className="text-xs text-muted-foreground">Takes ~7 minutes</span>
              </div>

              <div className="mt-6 space-y-1.5 border-t border-border pt-5">
                <p className="text-sm text-foreground">
                  Start at <span className="font-semibold text-signal">$0</span>. No generic reports. Only actionable ROI insights.
                </p>
                <p className="text-xs text-muted-foreground">
                  You can start small and decide next steps based on actual outcomes.
                </p>
              </div>
            </div>

            <div className="bg-gradient-dark p-10 text-background lg:col-span-5 lg:p-14">
              <p className="text-xs font-medium uppercase tracking-[0.18em] text-signal-glow">What you'll receive</p>
              <div className="mt-8 space-y-6">
                {[
                  { k: "01", t: "Signal Readiness Score", d: "A quantified view across opportunity, data, and team." },
                  { k: "02", t: "ROI Opportunity Map", d: "The 2–3 highest-impact areas, ranked by confidence." },
                  { k: "03", t: "90-Day Execution Plan", d: "A sequenced, defensible roadmap for leadership." },
                ].map((b) => (
                  <div key={b.k} className="flex gap-4 border-b border-background/10 pb-6 last:border-0">
                    <span className="font-serif text-2xl text-signal-glow">{b.k}</span>
                    <div>
                      <p className="text-base font-semibold text-background">{b.t}</p>
                      <p className="mt-1 text-sm text-background/60">{b.d}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Assessment;
